import { ErrorBlock } from '@/components/common/ErrorBlock'
import { StyledContent } from '@/components/common/StyledContent'
import { usePage } from '@/components/providers/PageProvider'
import { ParsedContentProvider, useParsedContent } from '@/components/providers/ParsedContentProvider'
import { MEDIAVINE_INLINE_CSS_CLASS } from '@/defs/ad'
import { createDynamicComponent } from '@/utils/factoryUtil'

import styles from './ArticlePageContent.module.scss'

const ArticleReport = createDynamicComponent({
  loader: () => import('@/components/common/Article'),
  name: 'ArticleReport',
})

export const ArticlePageContent = () => {
  const { page } = usePage()
  const { content, isPreview, slug, title } = page?.article || {}

  if (!content) return <ErrorBlock />

  return (
    <ParsedContentProvider articleSlug={slug} articleTitle={title} content={content} getReport={isPreview}>
      <ArticlePageContentInner />
    </ParsedContentProvider>
  )
}

const ArticlePageContentInner = () => {
  const { content, reports } = useParsedContent()

  return (
    <div className={styles.container}>
      {reports && <ArticleReport reports={reports} />}
      <StyledContent className={MEDIAVINE_INLINE_CSS_CLASS}>{content}</StyledContent>
    </div>
  )
}
